import { useEffect, useState } from "react";

// Единый общий «тик» времени для всего приложения вместо setInterval в каждом компоненте.
// Один интервал на всех подписчиков; отписка гасит таймер, когда подписчиков не осталось.
let _subscribers = new Set();
let _timer = null;
let _now = Date.now();

function _ensureTimer() {
    if (_timer != null) return;
    _timer = setInterval(() => {
        _now = Date.now();
        _subscribers.forEach((fn) => { try { fn(_now); } catch (e) { /* ignore */ } });
    }, 30000);
}

function _maybeStop() {
    if (_subscribers.size === 0 && _timer != null) {
        clearInterval(_timer);
        _timer = null;
    }
}

// Текущее время, обновляется раз в 30 секунд из общего таймера.
export default function useNow() {
    const [now, setNow] = useState(_now);
    useEffect(() => {
        _subscribers.add(setNow);
        _ensureTimer();
        setNow(_now); // синхронизируемся при монтировании
        return () => {
            _subscribers.delete(setNow);
            _maybeStop();
        };
    }, []);
    return now;
}